import { FontWeight, ITheme } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ colors }: ITheme) => ({
    root: {
      display: 'flex',
      gap: 13,
      listStyle: 'none',
    },
    item: {
      cursor: 'pointer',
      width: '100%',
      backgroundColor: 'var(--x-bg-12)',
      padding: [16, 20],
      border: '2px solid var(--x-bg-8)',
      borderRadius: '12px',
      '&.active': {
        border: `2px solid ${colors.secondary}`,
        '& > span': {
          color: colors.secondary,
        },
      },
      '&:hover': {
        border: `2px solid ${colors.secondary}`,
        '& > span': {
          color: colors.secondary,
        },
      },
    },
    text: {
      fontSize: 16,
      lineHeight: '16px',
      fontWeight: FontWeight.Medium,
      color: colors.black,
    },
  }),
  { name: 'generic-pills' },
);
export default useStyles;
